export default class CustomerDatasourceLicence {
	id: string;

	datasource: string;

	type: string;

	constructor(id: string, datasource: string, type: string) {
		this.id = id;
		this.datasource = datasource;
		this.type = type;
	}
}
